export default __webpack_public_path__ + "static/media/feuille-vigne-314x261.1fe19844.svg";